import { render, staticRenderFns } from "./appUser.vue?vue&type=template&id=006c6b8a&scoped=true&"
import script from "./appUser.vue?vue&type=script&lang=js&"
export * from "./appUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c6b8a",
  null
  
)

export default component.exports